/*
 * 3-Б3 «Составная услуга с паузой» — числа из макета «Каталог и клиенты - П2»: карточка
 * 760, зазор 14; строки шагов — сетка 28 / 1fr / 100 / 120 / 120 / 32 с зазором 8, рамка
 * радиусом 8; полоса времени — подписи 70 + дорожки высотой 34 радиусом 6; пауза —
 * штриховка зелёным, «занят» — цветом бренда (мастер) и тёплым (кресло).
 */

.screen {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: min(760px, 100% - 2 * var(--space-4));
  padding: 18px 20px;
  margin: var(--space-3) var(--space-4);
  font-size: 12.5px;
  line-height: 1.5;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.head {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.back {
  padding: 0;
  font: inherit;
  font-weight: var(--font-weight-semibold);
  color: var(--text-brand);
  cursor: pointer;
  background: none;
  border: 0;
}

.title {
  font-size: 15px;
  font-weight: var(--font-weight-semibold);
}

.sub {
  font-size: 12px;
  color: var(--text-secondary);
}

.total {
  margin-left: auto;
}

.steps {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.grid {
  display: grid;
  grid-template-columns: 28px 1fr 100px 120px 120px 32px;
  gap: 8px;
  align-items: center;
}

.gridHead {
  padding: 0 4px;
  font-size: 10.5px;
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-secondary);
}

.step {
  padding: 6px 4px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 8px;
}

.stepBad {
  background: var(--status-no-show-bg);
  border-color: var(--danger);
}

.handle {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-self: center;
}

.move {
  padding: 0 2px;
  font-size: 10px;
  line-height: 1.1;
  color: var(--text-secondary);
  cursor: pointer;
  background: none;
  border: 0;
}

.move:disabled {
  cursor: default;
  opacity: 0.35;
}

.input {
  width: 100%;
  min-width: 0;
  padding: 6px 10px;
  font: inherit;
  color: var(--text-primary);
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-radius: 6px;
}

.minutes {
  font-variant-numeric: tabular-nums;
}

.remove {
  justify-self: center;
  width: 28px;
  height: 28px;
  font-size: 13px;
  color: var(--danger);
  cursor: pointer;
  background: none;
  border: 0;
  border-radius: 6px;
}

.remove:hover {
  background: var(--status-no-show-bg);
}

.addRow {
  align-self: flex-start;
}

.error {
  padding: 9px 12px;
  color: var(--text-brand);
  border: 1px solid var(--border-strong);
  border-left: 3px solid var(--danger-hover);
  border-radius: 8px;
}

.question {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  padding: 9px 12px;
  color: var(--text-brand);
  border: 1px solid var(--border-strong);
  border-left: 3px solid var(--status-pending-fg);
  border-radius: 8px;
}

.timelineTitle {
  font-weight: var(--font-weight-semibold);
}

.timeline {
  display: grid;
  grid-template-columns: 70px 1fr;
  gap: 6px 10px;
  align-items: center;
  font-size: 11.5px;
}

.ticks {
  position: relative;
  height: 14px;
}

.tick {
  position: absolute;
  font-variant-numeric: tabular-nums;
  color: var(--text-secondary);
  white-space: nowrap;
  transform: translateX(-50%);
}

.tick:first-child {
  transform: none;
}

.tick:last-child {
  transform: translateX(-100%);
}

.laneLabel {
  font-weight: var(--font-weight-semibold);
}

.lane {
  display: flex;
  height: 34px;
  overflow: hidden;
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-radius: 6px;
}

.cell {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  padding: 0 4px;
  overflow: hidden;
  font-size: 11px;
  font-weight: var(--font-weight-semibold);
  text-overflow: ellipsis;
  white-space: nowrap;
  border-right: 1px solid var(--bg-card);
}

.cell:last-child {
  border-right: 0;
}

.busyEmployee {
  color: var(--bg-workspace);
  background: var(--text-brand);
}

.busyResource {
  color: var(--bg-card);
  background: var(--resource-busy);
}

.free {
  color: var(--hold-quarantine-fg);
  background: repeating-linear-gradient(
    135deg,
    var(--bg-card) 0 4px,
    var(--hold-quarantine-bg) 4px 8px
  );
}

.legend {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  font-size: 11px;
  color: var(--text-secondary);
}

.swatch {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  vertical-align: -1px;
  border-radius: 2px;
}

.swatchBusy {
  background: var(--text-brand);
}

.swatchFree {
  background: var(--bg-card);
  border: 1px dashed var(--hold-quarantine-border);
}

.pause {
  padding: 12px 14px;
  line-height: 1.55;
  color: var(--hold-quarantine-fg);
  background: var(--hold-quarantine-bg);
  border-radius: 10px;
}

.pause b {
  font-weight: var(--font-weight-semibold);
}

.note {
  font-size: 12px;
  color: var(--text-secondary);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

@media (max-width: 767px) {
  .card {
    width: auto;
    padding: 14px;
  }

  .gridHead {
    display: none;
  }

  .step {
    grid-template-areas:
      "handle name minutes remove"
      "handle emp res res";
    grid-template-columns: 28px 1fr 72px 32px;
  }

  .aHandle {
    grid-area: handle;
  }

  .aName {
    grid-area: name;
  }

  .aMinutes {
    grid-area: minutes;
  }

  .aEmp {
    grid-area: emp;
  }

  .aRes {
    grid-area: res;
  }

  .aRemove {
    grid-area: remove;
  }

  .timeline {
    overflow-x: auto;
  }
}
